import moment from 'moment'
import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2'
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete'
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput'
import { inputStyle } from 'views/pages/manage/masters/schoolMaster/schoolInfo/constant'
import { FaCheckSquare } from 'react-icons/fa';
import { validatePincode } from './utils'
import ATimePicker from 'views/pages/manage/common/form-fields-mui/ATimePicker'
import AWeekPicker from 'views/pages/manage/common/form-fields-mui/AWeekPicker'
import { ReactComponent as CloseIcon } from "assets/img/svg/closeSquare.svg";
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function'
import { Checkbox, Dialog, FormControlLabel, Tooltip } from '@mui/material'
import ATextarea from 'views/pages/manage/common/formFeilds/customInput/ATextarea'
import AButton from 'views/pages/manage/common/form-fields-mui/AButton'
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import { primaryCheckboxStyles } from 'views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant'
import StatusSyncingDropdown from './StatusSyncingDropdown'
import { getStatusCount } from './constant'
import CustomCopyToClipboard from 'views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard'
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch'
import { maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils'
export const DisplayViewData = ({ dataArray = [], heading, rowFormHandler = () => { }, form, setForm, isEdit, dropdown = {}, action, setOpen, toggleRequired, setOpenToggle, openToggle }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const getMultipleVal = (value, label) => {
        // return (value.map(item => (
        //     item?.label ?? item
        // ))).join(',')
        return <MultiSelectCellComponentWithSearch
            title={label}
            data={value}
            eyeIcon
        />
    }
    const formatField = (key, value) => {
        const isLinkOrUrl = /url|link/i.test(key); // Case-insensitive match

        if (isLinkOrUrl && value) {
            return (
                <div className='d-flex ellipsis-text-container'>
                    <Tooltip title={value}>
                        <div className='ellipsis-text-container'>
                            {value}
                        </div>
                    </Tooltip>
                    <CustomCopyToClipboard textToCopy={value} />
                </div>
            );
        }

        return value;
    };
    const columnStrategies = {
        checkbox: ({ value, dataRow, form }) => {
            const { checkboxOptions, type, key } = dataRow;

            const options =
                typeof checkboxOptions === 'function'
                    ? checkboxOptions()
                    : checkboxOptions || [];

            if (!options.length) return '-';

            if (type === 'single') {
                const selected = options.find(opt => opt.value === value);
                return selected?.title ?? '-';
            }

            if (type === 'multi') {
                const selected = options
                    .filter(opt =>
                        key ? value?.[opt.key] : form?.[opt.key]
                    )
                    .map(opt => opt.title);

                return selected.length ? selected.join(', ') : '-';
            }

            return '-';
        },

        locationHistory: ({ setOpen }) => (
            <AButton
                variant="link"
                size="xs"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true);
                }}
            >
                View
            </AButton>
        ),

        status: ({ value }) => (
            <div className="large-semi-bold label-color">
                {getStatusCount(value)}
            </div>
        ),

        vendorDetails: ({ dataRow }) => {
            const { onClickHandler } = dataRow;
            return (
                <AButton
                    variant="link"
                    size="xs"
                     className='no-ml-btn'
                    onClick={(e) => {
                        e.stopPropagation();
                        onClickHandler('view');
                    }}
                >
                    View Vendor Details
                </AButton>
            );
        },

        default: ({ value, key, label, dataRow }) => {
            const formattedValue = dataRow?.renderData?.(value);

            const finalValue =
                formattedValue && formatField(key, formattedValue)
                    ? formattedValue?.label ?? formatField(key, formattedValue)
                    : '-';

            const isActive = value?.label === 'ACTIVE';

            return (
                <div
                    className="large-semi-bold label-color"
                    style={isActive ? { color: '#05945B' } : {}}
                >
                    {Array.isArray(value)
                        ? getMultipleVal(value, label)
                        : finalValue}
                </div>
            );
        }
    };
    const getFormatCol = (value = '', key, label, dataRow = {}, extra = {}) => {
        const { colType } = dataRow;

        // 1. Checkbox strategy (based on colType)
        if (colType === 'checkbox') {
            return columnStrategies.checkbox({
                value,
                dataRow,
                form,
                ...extra
            });
        }

        // 2. Key-based strategy
        if (columnStrategies[key]) {
            return columnStrategies[key]({
                value,
                key,
                label,
                dataRow,
                ...extra
            });
        }

        // 3. Default fallback
        return columnStrategies.default({
            value,
            key,
            label,
            dataRow,
            ...extra
        });
    };
    const getVal = (col, index, form, setForm) => {
        switch (col?.colType) {
            case "input":
                return <AInput
                    key={`${index}-${col?.colKey}`} // Ensure unique key
                    type="text"
                    value={form?.[col?.colKey] || ""} // Dynamically access value
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                        col?.colKey == 'pincode' && validatePincode(value, setForm, dropdown)
                    }}
                    disabled={action == 'new' && !['city', 'district', 'state', 'country'].includes(col?.colKey) ? false : col.disabled} // Modify if needed
                    placeholder=""
                    regex={col.regex}
                    //style={selectStyles.control}
                    rightCustomIcon={col?.colKey == 'pincode' && <FaCheckSquare style={{
                        color: (!(form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 && form?.isValidPin)) ? '#D3D3D3' : '#00B0F5', backgroundColor: '#FFF', fontSize: '20px', top: '3px', right: '5px',
                        position: "absolute",
                        bottom: "0",
                        margin: "auto 0",
                        cursor: form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 ? "pointer" : "not-allowed",
                    }}
                    />}
                    //onClick={()=>{validatePincode(basicForm[col?.colKey])}}
                    style={inputStyle}
                    maxLength={col?.maxLength}
                />
            // Error
            case "select":
                return <AAutoComplete
                    placeholder=""
                    currentValue={col?.colKey == 'businessAreaType' ? form?.[col?.colKey]?.[0] : form?.[col?.colKey]}
                    handleChange={(value) => {
                        col?.colKey == 'businessUnitType' ? rowFormHandler(col?.colKey, [value], setForm) : rowFormHandler(col?.colKey, value, setForm);
                        col.customHandleChange && col.customHandleChange(setForm, value);
                    }}
                    items={dropdown?.[col?.colKey]}
                    isMulti={col?.isMulti ?? false}
                    isShowCount={col?.isMulti ?? false}
                    style={{ control: inputStyle }}
                    isInputChange={true}
                    isDisabled={action == 'new' ? false : col.disabled}
                />; // Warning
            case "date":
                return <CustomDatePickerV2
                    style={{ input: inputStyle }}
                    placeHolder=""
                    value={form?.[col?.colKey]}
                    handler={(index, date) => {
                        rowFormHandler(col?.colKey, moment(date).startOf('day'), setForm)
                    }}
                    //isStartDate={true}
                    // minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                    // maxDate={new moment(new Date())}
                    disabled={action == 'new' ? false : col.disabled}
                />
            case 'time':
                return <ATimePicker
                    timestamp={form?.[col?.colKey]}
                    handler={(time) => {
                        col?.colKey == 'startTime' ? setForm({
                            ...form,
                            [col?.colKey]: time,
                            'endTime': ''
                        }) : rowFormHandler(col?.colKey, time, setForm)
                    }}
                    disabled={col?.colKey == 'endTime' && !form?.startTime}
                    minTime={col?.colKey == 'endTime' && form?.startTime}
                // maxTime={new Date('2025-05-12T22:00:00')}
                />
            case 'week':
                return <AWeekPicker
                    selectedDays={form?.[col?.colKey] ?? []}
                    onChange={(week) => {
                        rowFormHandler(col?.colKey, week, setForm)
                    }}
                    disabled={action == 'new' ? false : col.disabled}
                    multiSelect={col?.isMulti}
                />
            case 'textArea':
                return <AddApplicationListPopup
                    value={form?.[col?.colKey] ?? ''}
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                    }}
                    viewOnly={action == 'new' ? false : col.disabled}
                />
            case 'dialoge':
                return <AButton
                    variant="link"
                    size="xs"
                    //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
                    onClick={
                        (e) => {
                            e.stopPropagation();
                            setOpen(true)
                        }
                    }
                >
                    View
                </AButton>
            case 'checkbox': {
                const options =
                    typeof col?.checkboxOptions === "function"
                        ? col.checkboxOptions(col, rowFormHandler, form, setForm)
                        : col?.checkboxOptions || [];

                // SINGLE SELECT (like radio)
                if (col?.type === 'single') {
                    return (
                        <div className="d-flex" style={{ gap: "8px" }}>
                            {options.map(item => (
                                <FormControlLabel
                                    key={item.value}
                                    control={
                                        <Checkbox
                                            checked={form?.[col.colKey] === item.value}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    rowFormHandler(col.colKey, item.value, setForm);
                                                }
                                            }}
                                        />
                                    }
                                    label={item.title}
                                />
                            ))}
                        </div>
                    );
                }

                // MULTI SELECT (independent checkboxes)
                if (col?.type === 'multi') {
                    return (
                        <div className="d-flex" style={{ gap: "8px" }}>
                            {options.map(item => (
                                <FormControlLabel
                                    key={item.key}
                                    control={
                                        <Checkbox
                                            checked={!!form?.[item.key]}
                                            onChange={(e) => {
                                                rowFormHandler(item.key, e.target.checked, setForm);
                                            }}
                                        />
                                    }
                                    label={item.title}
                                />
                            ))}
                        </div>
                    );
                }
                return null;
            }
            case 'status':
                return <StatusSyncingDropdown
                    hasUpdate={true}
                    statusValue={form?.[col?.colKey] ?? {}}
                    handler={(value) => {
                        rowFormHandler(col?.colKey, value, setForm)
                    }}
                    setAnchorEl={setAnchorEl}
                    anchorEl={anchorEl}
                />
            case 'button': {
                const { onClickHandler } = col || {}
                return <AButton
                    // size="xs"
                    variant="link"
                    //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
                    className='no-ml-btn'
                    onClick={
                        (e) => {
                            e.stopPropagation();
                            onClickHandler()
                        }
                    }
                >
                    Add/Edit Vendor Details
                </AButton>
            }
            default:
                return <></>
        }
    }
    return (<>
        {(heading || toggleRequired) && (
            <div className='d-flex align-items-center justify-content-between'>
                <div className='mt-24 large-semi-bold label-color'> {heading}</div>
                {toggleRequired && <div className='ml-3  br-8 cursor' onClick={() => { setOpenToggle((prev) => (!prev)) }}>{openToggle ? <Uparrow /> : <DownArrow />}</div>}
            </div>
        )}
        {toggleRequired ? openToggle && <Row>
            {dataArray.map((col, index) => {

                return <Col md={4} className='mt-24'>
                    <div>

                        <div className='regular-small color-grey-60 mb-1'>
                            {col?.label}
                        </div>
                        <div className='large-semi-bold label-color'>
                            {
                                !isEdit ?
                                    col?.colKey == 'contactNumbers' ?
                                        <AddApplicationListPopup
                                            value={form?.[col?.colKey] ?? ''}
                                            handler={(value) => {
                                                rowFormHandler(col?.colKey, value, setForm)
                                            }}
                                            viewOnly={true}
                                        />
                                        :
                                        getFormatCol(col?.colKey == 'effectiveDate' ? moment(form?.[col?.colKey]).format('DD/MM/YYYY') : form?.[col?.colKey], col?.colKey, col?.label, col, { setOpen })
                                    : getVal(col, index, form, setForm)
                            }
                        </div>
                    </div>
                </Col>

            })}
        </Row> :
            <Row>
                {dataArray.map((col, index) => {
                    return <Col md={4} className='mt-24'>
                        <div>

                            <div className='regular-small color-grey-60 mb-1'>
                                {col?.label}
                            </div>
                            <div className='large-semi-bold label-color'>
                                {
                                    !isEdit ?
                                        col?.colKey == 'contactNumbers' ?
                                            <AddApplicationListPopup
                                                value={form?.[col?.colKey] ?? ''}
                                                handler={(value) => {
                                                    rowFormHandler(col?.colKey, value, setForm)
                                                }}
                                                viewOnly={true}
                                            />
                                            :
                                            getFormatCol(
                                                col?.colKey == 'effectiveDate'
                                                    ? moment(form?.[col?.colKey]).format('DD/MM/YYYY')
                                                    : form?.[col?.colKey],
                                                col?.colKey,
                                                col?.label,
                                                col,
                                                { setOpen }   // ✅ FIX
                                            )
                                        : getVal(col, index, form, setForm)
                                }
                            </div>
                        </div>
                    </Col>

                })}
            </Row>
        }
    </>
    )
}

export const getAuditDetails = (updatedBy, updatedOn) => {

    return <div className='color-grey-60 regular-small mt-3'>
        Last updated on {moment(updatedOn).format('DD/MM/YYYY')} at {moment(updatedOn).format('hh:mm A')} by {updatedBy}
    </div>
}

// import React, { useState } from 'react';
// import { Dialog } from '@mui/material';
// import ATextarea from '../../../common/formFeilds/customInput/ATextarea';

// import AButton from '../../../common/form-fields-mui/AButton';
// import { regex } from '../../../common/constant';

export const AddApplicationListPopup = ({
    value,
    handler: handleChange,
    viewOnly
}) => {

    // const { isOpen, viewOnly, initialPhoneNo = "" } = dialogInfo;
    const [isOpen, setOpen] = useState(false)
    const closeDialog = () => setOpen(false);
    const updateLists = (inputVal) => {
        const phoneList = inputVal.split(',').filter(val => Boolean(val));
        if (phoneList.some(el => el.length != 10)) {
            failureToast('Please enter a valid phone number')
            return
        }
        handleChange(phoneList.join(","));
        closeDialog();
    }



    return (
        <> <AButton
            variant="link"
            size="xs"
            //disabled={rowForm?.applicationLevel === 'NO' || !params?.row?.isNew}
            onClick={
                (e) => {
                    e.stopPropagation();
                    setOpen(true)
                }
            }
        >
            {viewOnly ? 'View' : value.length ? 'Edit' : 'Add'}
        </AButton>
            {isOpen && <DialogOpen
                isOpen={isOpen}
                updateLists={updateLists}
                closeDialog={closeDialog}
                value={value}
                viewOnly={viewOnly}
            />
            }
        </>
    );
}

const DialogOpen = ({
    isOpen,
    updateLists,
    closeDialog,
    value,
    viewOnly
}) => {
    const [inputVal, setInputVal] = useState(value);
    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="sm"
        >
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    <h3>Branch Phone No.</h3>
                    <CloseIcon className='cursor' onClick={closeDialog} />
                </div>

                <ATextarea
                    placeholder='Enter Phone no.'
                    onChange={val => setInputVal(val)}
                    disabled={viewOnly}
                    value={viewOnly ? maskPhoneNumber(inputVal) : inputVal}
                    //maxlength = {110}
                    regex={/^(\d+)(,(\d*)?){0,9}?$|^$/} //regex that allows maximum 10 comma separated numbers
                />

                {!viewOnly && <AButton
                    variant='primary_filled'
                    className='no-ml-btn d-block'
                    onClick={() => updateLists(inputVal)}
                    disabled={!inputVal}
                >
                    Save
                </AButton>
                }

            </div>

        </Dialog>
    )
}